import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data", "options", "datasetLabel"],
  mounted() {
    this.renderLineChart();
  },
  computed: {
    chartData: function() {
      return this.data;
    }
  },
  methods: {
    renderLineChart: function() {
      let color = "";
      let totalValue = 0;
      for (let index = 0; index < this.chartData.length; index++) {
        totalValue += this.chartData[index];
      }
      let percentage = totalValue / this.chartData.length;
      if (percentage <= 30) {
        color = "green";
      } else if (percentage > 30 && percentage <= 60) {
        color = "yellow";
      } else {
        color = "red";
      }
      this.renderChart(
        {
          labels: [0, 10, 20, 30, 40, 50, 60],
          datasets: [
            {
              label: this.datasetLabel,
              backgroundColor: color,
              data: this.chartData
            }
          ]
        },
        this.options
      );
    }
  },
  watch: {
    data: function() {
      this.renderLineChart();
    }
  }
};
